import axios from 'axios'
// import lockr from 'lockr'
import { Message } from 'element-ui'
// axios 配置
// axios.defaults.timeout = 5000
axios.defaults.headers.get['Content-Type'] = 'application/json;charset=UTF-8'
// if(lockr.get("WToken")!=undefined){
//   axios.defaults.headers.post['WToken']=lockr.get("WToken")
// }

let baseURL = "https://www.jszc-wjsc.com:8553"
// let baseURL = "http://192.168.2.72:8553"

// axios.defaults.timeout = 1000 * 15

// POST传参序列化y

// 返回状态判断
axios.interceptors.response.use((res) => {
    if (res.data.state) {
        return res
    } else {
        Message.error(res.data.message);
        // return Promise.reject(res)
    }
}, (error) => {
    console.log(error)
})

let fetch = function (url, params) {
    return new Promise((resolve, reject) => {
        axios.post(baseURL + url, params)
            .then(res => {
                if (res != undefined) {
                    resolve(res.data)
                }
            })
            .catch((error) => {
                reject(error)
            })
    })
}


let ResetToken = function () {
    // if(lockr.get("Token")!=undefined){
    //   axios.defaults.headers.post['Token']=""
    //   axios.defaults.headers.post['Token']=lockr.get("Token")
    // }
}

export default fetch


// WEBPACK FOOTER //
// ./src/api/api.js